<template>
  <FilterLayout title="Type" :options="options" :selectedText="selectedText" auto @clear="$emit('input', options.first().item)">
    <div class="hvh-flex aling-center mb-3 pr-5" v-for="(option, ind) in options" :key="option.item">
      <RadioBox :value="value === option.item || (!value && !ind)" @input="$emit('input', option.item)" />
      <span class="clickable no-wrap ml-2" @click="$emit('input', option.item)">{{ option.item }} ({{ option.count }})</span>
    </div>
  </FilterLayout>
</template>

<script>
import RadioBox from '../../../common/form/radiobox/RadioBox.vue';
import FilterLayout from './FilterLayout.vue';
import axios from '../../../../axios';
import { errorDebug, hashCode } from '../../../../libraries/common';
export default {
  components: { RadioBox, FilterLayout },
  props: ['value', 'filters'],
  data() {
    return {
      options: null,
      showOptions: true,
    };
  },
  computed: {
    selectedText() {
      return (this.options || []).findIndex(f => f.item === this.value) > 0 && this.value;
    },
    filterHashCode() {
      return hashCode(this.filters);
    },
  },
  methods: {
    getFilterOptions() {
      axios.post('/Analytics/Cohorts/TypesFilterOptions', this.filters)
        .then(response => this.options = response.data)
        .catch(errorDebug)
    },
  },
  watch: {
    filterHashCode() {
      this.getFilterOptions();
    },
  },
  mounted() {
    this.getFilterOptions();
  },

}
</script>

<style lang="scss" scoped>
</style>